import { isFlambeauEmail } from "../calendar/email";
import { useAuth } from "./auth-context";

export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return isFlambeauEmail(user?.email);
}
